<nz-skeleton [nzLoading]="!formFieldInfo" nzActive="true"></nz-skeleton>
<form nz-form [formGroup]="formGroup">
    <div nz-row class="row">
        <span *ngFor="let c of formFieldInfo" [hidden]="c.isHidden" [ngClass]="getCol(c)">
            <div *ngIf="c.fieldTypeCode == 'TITLE'">
                <app-component-title [formFieldInfo]="c" class="directive-component"></app-component-title>
            </div>
            <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT' && isShowComponent(c)">
                <app-component-text id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-text>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE_COMPLEX' && isShowComponent(c)">
                <app-component-table-complex id="TABLE_{{c.fieldCode}}" (tableEmit)="tableOutput($event)" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" [formData]="data" [formFieldInfo]="c" class="directive-component" [modalTitle]="title">
                </app-component-table-complex>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER' && isShowComponent(c)">
                <app-component-number id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-number>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'TEXTAREA' && isShowComponent(c)">
                <app-component-textarea id="TABLE_{{c.fieldCode}}" 
                    [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" 
                    [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-textarea>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'DATE' && isShowComponent(c)">
                <app-component-date id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-date>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'DATETIME' && isShowComponent(c)">
                <app-component-datetime id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-datetime>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'SELECTLIST_SINGLE' && isShowComponent(c)">
                <app-component-single-select id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c"
                    (selectEmit)="selectOutput($event)" [inputData]="selectChildData" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-single-select>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'SPACE' && isShowComponent(c)">
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'MULTIPLE_CHOICE' && isShowComponent(c)">
                <app-component-multiple-choice id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c"
                    class="multi-choice-control parent-section directive-component"
                    [ngClass]="formFieldCode" [attr.query]="formFieldCode"
                    [inputCustomfieldOptionList]="getMultipleChoiceCustomfieldList(c)" [itemList]="getSubItemsList(c)"
                    [formFieldCode]="formFieldCode"
                    [listFormFieldInfo]="formFieldInfo" [formGroup]="formGroup" [formData]="data" [modalTitle]="title">
                </app-component-multiple-choice>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'RADIO_BUTTON' && isShowComponent(c)">
                <app-component-radiobutton id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                    class="radio-button-control parent-section directive-component" [formData]="data" [modalTitle]="title"
                    [ngClass]="formFieldCode" [attr.query]="formFieldCode"
                    [listFormFieldInfo]="formFieldInfo" [itemList]="getSubItemsList(c)">
                </app-component-radiobutton>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'LABEL' && isShowComponent(c)">
                <app-component-label id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" class="directive-component" >
                </app-component-label>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'CHECK_BOX' && isShowComponent(c)">
                <app-component-checkbox id="TABLE_{{c.fieldCode}}" [formFieldInfo]="c" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formGroup]="formGroup" [formData]="data" [modalTitle]="title" class="directive-component">
                </app-component-checkbox>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER_CURRENCY' && isShowComponent(c)">
                <app-component-number-currency id="TABLE_{{c.fieldCode}}" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formFieldInfo]="c" [formGroup]="formGroup" [formData]="data" [modalTitle]="title"  class="directive-component">
                </app-component-number-currency>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT_CHECK_BOX' && isShowComponent(c)">
                <app-component-text-checkbox id="TABLE_{{c.fieldCode}}" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formFieldInfo]="c" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-text-checkbox>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'DATE_CHECK_BOX' && isShowComponent(c)">
                <app-component-date-checkbox id="TABLE_{{c.fieldCode}}" [ngClass]="formFieldCode" [attr.query]="formFieldCode" [formFieldInfo]="c" [formGroup]="formGroup" class="directive-component" [formData]="data" [modalTitle]="title">
                </app-component-date-checkbox>
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE' && isShowComponent(c)">
            </nz-form-item>
            <nz-form-item *ngIf="c.fieldTypeCode == 'UPLOAD_FILE' && isShowComponent(c)">
            </nz-form-item>
        </span>
    </div>
</form>
<div *nzModalFooter>
    <button class="btn btn-back" title="Thoát" (click)="cancel()">
        <span nz-icon nzType="reload"></span> Thoát
    </button>
    <button class="btn btn-skip" title="Lưu" (click)="saveForm()">
        <span nz-icon nzType="save"></span> Lưu
    </button>
</div>